var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"terms-page"},[_c('div',{staticClass:"terms-lang"},[_c('iv-language-button',{attrs:{"sync":""}})],1),_c(_vm.i18nComponent,{tag:"component",attrs:{"support-email":_vm.supportEmail,"support-email-href":_vm.supportEmailHref},on:{"back":_vm.goBack,"print":_vm.printPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }